import { Literal, Runtype, Union } from "runtypes";

const LEARN_BASE_URL = `https://learn.hex.tech` as const;
export const MARKETING_SITE_BASE_URL = `https://hex.tech` as const;
const DOCS_BASE_URL = `${LEARN_BASE_URL}/docs` as const;
const QUICKSTART_BASE_URL = `${LEARN_BASE_URL}/tutorials/quickstart` as const;
const TUTORIAL_BASE_URL = `${LEARN_BASE_URL}/tutorials` as const;
const AI_BASE_URL =
  `${LEARN_BASE_URL}/docs/getting-started/ai-overview` as const;
const TRUST_BASE_URL = "https://trust.hex.tech" as const;

// TODO: rename to LEARN_LINKS
export const DOCS_LINKS = {
  // top level
  Root: LEARN_BASE_URL,
  Changelog: `${LEARN_BASE_URL}/changelog` as const,
  Trust: TRUST_BASE_URL,
  // Core Docs
  Docs: DOCS_BASE_URL,
  AllowedDomains:
    `${DOCS_BASE_URL}/administration/overview#allowed-domains` as const,
  AgentIntegrationDataConnectionAccess:
    `${DOCS_BASE_URL}/api-integrations/hex-agent-data-connection-access` as const,
  Api: `${DOCS_BASE_URL}/explore-data/notebook-view/hex-api/hex-api-overview` as const,
  ApiPersonalAccessTokens:
    `${DOCS_BASE_URL}/explore-data/notebook-view/hex-api/hex-api-overview#personal-access-tokens` as const,
  ApiWorkspaceTokens:
    `${DOCS_BASE_URL}/explore-data/notebook-view/hex-api/hex-api-overview#workspace-tokens` as const,
  AppLinks:
    `${DOCS_BASE_URL}/share-insights/apps/publish-and-share-apps#distribute-a-link-to-your-app` as const,
  AppView: `${DOCS_BASE_URL}/share-insights/apps/app-builder` as const,
  AppIntroduction:
    `${DOCS_BASE_URL}/share-insights/apps/apps-introduction` as const,
  AppNotifications:
    `${DOCS_BASE_URL}/share-insights/app-notifications` as const,
  AppNotificationsScreenshot:
    `${DOCS_BASE_URL}/share-insights/app-notifications#attaching-screenshots` as const,
  AppRunSettings:
    `${DOCS_BASE_URL}/share-insights/apps/app-run-settings` as const,
  AppTabs: `${DOCS_BASE_URL}/share-insights/apps/app-builder#app-tabs` as const,
  Archive: `${DOCS_BASE_URL}/organize-content/archive` as const,
  AskMagic:
    `${DOCS_BASE_URL}/share-insights/explore#exploring-from-ask-magic-beta` as const,
  AuditLogs:
    `${DOCS_BASE_URL}/administration/workspace_settings/audit-logs/audit-logs-overview` as const,
  BigQueryStorageAPI:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-bigquery#basic-settings` as const,
  BuiltInVars:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/environment-views#built-in-variables` as const,
  Calculations: `${DOCS_BASE_URL}/explore-data/cells/calculations` as const,
  CellExecutionOrder:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/environment-views#cell-execution-order` as const,
  CellLinks:
    `${DOCS_BASE_URL}/explore-data/projects/project-execution/execution-model#how-cells-link-together` as const,
  CLI: `${DOCS_BASE_URL}/api-integrations/cli` as const,
  Collections: `${DOCS_BASE_URL}/organize-content/collections` as const,
  CollectionsPermissions:
    `${DOCS_BASE_URL}/organize-content/collections#permissions` as const,
  Components: `${DOCS_BASE_URL}/explore-data/components` as const,
  ComponentsPermissions:
    `${DOCS_BASE_URL}/explore-data/components#component-permissions` as const,
  ComputeProfile:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/environment-views#compute-profiles` as const,
  ProjectKernels:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/project-kernels` as const,
  CustomStyling:
    `${DOCS_BASE_URL}/administration/workspace_settings/workspace-custom-styling` as const,
  CustomThemes:
    `${DOCS_BASE_URL}/administration/workspace_settings/workspace-custom-styling#custom-app-themes ` as const,
  AdvancedComputeSettings: `${DOCS_BASE_URL}/administration/workspace_settings/compute`,
  AdvancedComputeSpendLimit: `${DOCS_BASE_URL}/administration/workspace_settings/compute#set-a-compute-spend-limit`,
  AdvancedComputeBilling: `${DOCS_BASE_URL}/administration/workspace_settings/compute#compute-usage-based-billing`,
  DataConnections:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/data-connections-introduction` as const,
  DataConnectionsDatabaseSecurity:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/data-connections-introduction#database-security` as const,
  DataConnectionsSchemaFiltering:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/data-connections-introduction#schema-filtering` as const,
  DataConnectionsAccess:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/data-connections-introduction#workspace-data-connection-permissions` as const,
  DataConnectionsCanQueryPermissions:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/data-connections-introduction#can-query` as const,
  DataConnectionsCanViewResultsPermissions:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/data-connections-introduction#can-view-results` as const,
  // dc specific pages
  AlloyDB: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-alloydb`,
  Athena: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-amazon-athena`,
  BigQuery: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-bigquery`,
  ClickHouse: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-clickhouse`,
  CloudSQL: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-cloudsql`,
  CloudSQLMySQL: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-cloudsql`,
  CloudSQLPostgres: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-cloudsql`,
  CloudSQLSQLServer: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-cloudsql`,
  Databricks: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-databricks`,
  DB2: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-ibm-db2`,
  Dremio: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-dremio`,
  MariaDB: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-mariadb`,
  Materialize: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-materialize`,
  Motherduck: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-motherduck`,
  MySQL: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-mysql`,
  Postgres: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-postgres`,
  PrestoDB: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-presto`,
  RDS: `${DOCS_BASE_URL}/connect-to-data/data-connections/data-connections-introduction`,
  Redshift: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-amazon-redshift`,
  Snowflake: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-snowflake`,
  SnowflakeOAuthSchemaAuth:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-snowflake#applying-oauth-permissions-to-schema-data` as const,
  SQLServer: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-microsoft-sql-server`,
  Starburst: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-starburst`,
  Trino: `${DOCS_BASE_URL}/connect-to-data/data-connections/setup-guides/connect-to-trino`,
  DataframeSQL:
    `${DOCS_BASE_URL}/explore-data/cells/sql-cells/sql-cells-introduction#dataframe-sql` as const,
  DefaultStatusWorkspaceSetting:
    `${DOCS_BASE_URL}/administration/workspace_settings/workspace-assets#default-status` as const,
  DirectorySync:
    `${DOCS_BASE_URL}/administration/workspace_settings/directory-sync` as const,
  StatusesAndCategories:
    `${DOCS_BASE_URL}/organize-content/statuses-categories` as const,
  Endorsements:
    `${DOCS_BASE_URL}/organize-content/statuses-categories#endorsed-statuses` as const,
  EndorsementApiProject:
    `${DOCS_BASE_URL}/api/api-reference#operation/UpdateProject` as const,
  EndorsementApiSemanticProject:
    `${DOCS_BASE_URL}/api/api-reference#operation/UpdateSemanticProject` as const,
  EndorsementApiDataConnection:
    `${DOCS_BASE_URL}/api/api-reference#operation/UpdateDataConnectionSchema` as const,
  EndorsedMode:
    `${DOCS_BASE_URL}/organize-content/statuses-categories#endorsed-mode` as const,
  ExternalFileProjectConfig:
    `${DOCS_BASE_URL}/connect-to-data/cloud-storage-integrations#import-files-from-your-cloud-storage-integration` as const,
  ExternalFileWorkspaceConfig:
    `${DOCS_BASE_URL}/administration/workspace_settings/workspace-assets#external-file-integrations` as const,
  WritebackCell:
    `${DOCS_BASE_URL}/explore-data/cells/data-cells/writeback-cells` as const,
  DbtIntegration:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/dbt-integration` as const,
  DbtIntegrationMetadata:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/dbt-integration#dbt-metadata-integration` as const,
  DbtIntegrationTroubleshooting:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/dbt-integration#troubleshooting` as const,
  Embedding: `${DOCS_BASE_URL}/share-insights/embedding` as const,
  EnvironmentViews:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/environment-views` as const,
  EnvironmentVariables:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/environment-views#environment-variables` as const,
  GitHubPackageImport:
    `${DOCS_BASE_URL}/administration/workspace_settings/workspace-assets#github-packages` as const,
  GitHubPackageUse:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/using-packages#github-packages` as const,
  GitHubSync: `${DOCS_BASE_URL}/explore-data/projects/git-sync` as const,
  GitExport: `${DOCS_BASE_URL}/explore-data/projects/git-export` as const,
  GitSyncReviews:
    `${DOCS_BASE_URL}/explore-data/projects/git-sync#git-sync-and-reviews` as const,
  IPAddresses:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/allow-connections-from-hex-ip-addresses` as const,
  InferNumericDatatypes:
    `${DOCS_BASE_URL}/explore-data/cells/sql-cells/sql-cells-introduction#infer-numeric-datatypes` as const,
  Jinja: `${DOCS_BASE_URL}/explore-data/cells/using-jinja` as const,
  KernelLimits:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/project-kernels#manually-killing-active-kernels` as const,
  KernelIdleTimeout:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/project-kernels#kernel-timeouts` as const,
  LegacyAppView: `${DOCS_BASE_URL}/share-insights/apps/app-builder` as const,
  LegacyChartCell:
    `${DOCS_BASE_URL}/explore-data/cells/visualization-cells/chart-cells#legacy-charts` as const,
  Library:
    `${DOCS_BASE_URL}/organize-content/statuses-categories#library` as const,
  LogicView:
    `${DOCS_BASE_URL}/explore-data/notebook-view/develop-your-notebook` as const,
  MagicSchemaDescriptions:
    `${DOCS_BASE_URL}/hex-magic/magic-tips#magic-knows-about-table-and-column-metadata` as const,
  ManagingMemory:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/manage-memory` as const,
  NotionShareFAQ:
    `${DOCS_BASE_URL}/share-insights/embedding#how-do-permissions-work-for-notion-link-previews` as const,
  NotebookAgent:
    `${DOCS_BASE_URL}/explore-data/notebook-view/notebook-agent` as const,
  OAuthDataConnections:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/oauth-data-connections` as const,
  OAuthExpiredCredentials:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/oauth-data-connections#tokens-and-expiration` as const,
  OAuthSchemaAuth:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/oauth-data-connections#applying-oauth-permissions-to-schema-data` as const,
  OAuthTokenSharing:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/oauth-data-connections#credential-sharing` as const,
  OptimizeDataConnectionsForAgents:
    `${TUTORIAL_BASE_URL}/ai-best-practices/optimizing-data-connections-for-agents` as const,
  ParameterizeSQL:
    `${DOCS_BASE_URL}/explore-data/cells/using-jinja#sql-parameterization` as const,
  Permissions:
    `${DOCS_BASE_URL}/collaborate/sharing-and-permissions/sharing-permissions` as const,
  PivotCells:
    `${DOCS_BASE_URL}/explore-data/cells/transform-cells/pivot-cells` as const,
  LegacyPivotCells:
    `${DOCS_BASE_URL}/explore-data/cells/transform-cells/pivot-cells#legacy-pivots` as const,
  PipInstall:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/using-packages#install-new-packages-through-pip` as const,
  UvPipInstall:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/using-packages#install-new-packages-through-uv-pip` as const,
  Preferences:
    `${DOCS_BASE_URL}/administration/user-settings#preferences` as const,
  ProjectFilters:
    `${DOCS_BASE_URL}/share-insights/apps/project-filters` as const,
  Projects:
    `${DOCS_BASE_URL}/explore-data/projects/projects-introduction` as const,
  Privacy: `${DOCS_BASE_URL}/trust/privacy-policy` as const,
  Publishing:
    `${DOCS_BASE_URL}/share-insights/apps/publish-and-share-apps` as const,
  PublicSharePermissions:
    `${DOCS_BASE_URL}/administration/workspace_settings/workspace-security#share-projects-to-web` as const,
  QueryCaching:
    `${DOCS_BASE_URL}/explore-data/cells/sql-cells/query-caching` as const,
  QueryMode:
    `${DOCS_BASE_URL}/explore-data/cells/sql-cells/sql-cells-introduction#query-mode` as const,
  QueryCellStreaming:
    `${DOCS_BASE_URL}/explore-data/cells/sql-cells/sql-cells-introduction#query-result-cell-compatibility` as const,
  Reviews: `${DOCS_BASE_URL}/collaborate/reviews` as const,
  RSupport: `${DOCS_BASE_URL}/explore-data/cells/r-support` as const,
  RunModes:
    `${DOCS_BASE_URL}/explore-data/projects/project-execution/run-modes-and-cell-staleness` as const,
  RunningAppsCantRefresh:
    `${DOCS_BASE_URL}/share-insights/apps/running-apps#cant-refresh` as const,
  SavedViews: `${DOCS_BASE_URL}/share-insights/apps/saved-views` as const,
  Scheduling:
    `${DOCS_BASE_URL}/share-insights/scheduled-runs-and-notifications` as const,
  ScheduleNotifications:
    `${DOCS_BASE_URL}/share-insights/scheduled-runs-and-notifications#scheduled-run-notifications` as const,
  ScheduleNotificationsAttachCsvExports:
    `${DOCS_BASE_URL}/share-insights/app-notifications#attaching-csv-data-exports` as const,
  ScheduleNotificationsUpdatePublishedResults:
    `${DOCS_BASE_URL}/share-insights/apps/app-run-settings` as const,
  ScheduleNotificationsSqlCaching:
    `${DOCS_BASE_URL}/share-insights/scheduled-runs#scheduled-runs--sql-caching` as const,
  Secrets:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/environment-views#secrets` as const,
  SemanticModels:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/intro` as const,
  SSHConnections:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/connect-via-ssh` as const,
  ShareWithWorkspace:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/data-connections-introduction#add-shared-connections` as const,
  SharedAssetRoleDowngradeToViewer:
    `${DOCS_BASE_URL}/collaborate/sharing-and-permissions/project-sharing#unable-to-edit-due-to-missing-workspace-asset-permissions` as const,
  SharedAssetRoleDowngradeToNoAccess:
    `${DOCS_BASE_URL}/collaborate/sharing-and-permissions/project-sharing#unable-to-view-a-project-due-to-missing-data-connection-permissions` as const,
  SnowparkIntegration:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/snowpark` as const,
  Suggestions: `${DOCS_BASE_URL}/agent-management/suggestions` as const,
  BigframesIntegration:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/bigquery-dataframes` as const,
  Terms: `${DOCS_BASE_URL}/legal/terms-and-conditions` as const,
  Timezones:
    `${DOCS_BASE_URL}/explore-data/cells/visualization-cells/chart-cells#chart-cell-timezones` as const,
  TimezonesWorkspaceSetting:
    `${DOCS_BASE_URL}/administration/workspace_settings/overview#workspace-timezone` as const,
  UpdatePublishedResults:
    `${DOCS_BASE_URL}/share-insights/apps/running-apps#manually-refreshing-an-ap` as const,
  UpgradingProjects:
    `${DOCS_BASE_URL}/tips-and-tricks/upgrading-projects-to-hex-2.0` as const,
  UploadingFiles:
    `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/files` as const,
  UserRoles:
    `${DOCS_BASE_URL}/collaborate/sharing-and-permissions/roles` as const,
  // TODO (dscott): docs link for "Use native Python dates"
  UserGroups:
    `${DOCS_BASE_URL}/administration/workspace_settings/overview#groups` as const,
  UseNativeDates:
    `${DOCS_BASE_URL}/explore-data/cells/sql-cells/sql-cells-introduction` as const,
  VersionControl:
    `${DOCS_BASE_URL}/explore-data/projects/history-and-versions` as const,
  VisualFiltering:
    `${DOCS_BASE_URL}/explore-data/cells/visualization-cells/chart-cells#configuring-a-chart-cell` as const,
  MigratingFromVisualFiltering:
    `${DOCS_BASE_URL}/explore-data/cells/visualization-cells/chart-cells#configuring-a-chart-cell` as const,
  TableDisplayFilters:
    `${DOCS_BASE_URL}/explore-data/cells/visualization-cells/table-display-cells#filters` as const,
  Transfers:
    `${DOCS_BASE_URL}/explore-data/projects/create-and-manage-projects#transfer-ownership` as const,
  // Quickstart
  QuickStart: QUICKSTART_BASE_URL,
  Hex101: `${QUICKSTART_BASE_URL}/hex-101` as const,
  Admin101: `${QUICKSTART_BASE_URL}/workspace-admin-101` as const,
  // Tutorials
  Tutorials: TUTORIAL_BASE_URL,
  AgentCreditLimits: `${DOCS_BASE_URL}/administration/credits`,
  AgentCreditUsageControls: `${DOCS_BASE_URL}/administration/credits#credit-usage-controls`,
  Magic: AI_BASE_URL,
  MagicBringYourOwnKey: `${DOCS_BASE_URL}/trust/ai-data-privacy#bring-your-own-key-byok`,
  MagicDataPrivacy: `${DOCS_BASE_URL}/trust/ai-data-privacy` as const,
  MagicDataRetentionModels:
    `${DOCS_BASE_URL}/trust/ai-data-privacy#third-party-partner-interactions` as const,
  MagicTypeahead: `${DOCS_BASE_URL}/explore-data/cells/code-typeahead` as const,
  MagicTerms:
    `${DOCS_BASE_URL}/legal/hex-service-agreement#hex-magic-and-hex-magic-typeahead-collectively-hex-magic` as const,
  ImproveMagic:
    `${TUTORIAL_BASE_URL}/connect-to-data/improving-hex-magic` as const,
  ImproveMagicEndorsements:
    `${TUTORIAL_BASE_URL}/connect-to-data/improving-hex-magic#endorsements` as const,
  ImproveMagicMetadata:
    `${TUTORIAL_BASE_URL}/connect-to-data/improving-hex-magic#what-kind-of-metadata-is-helpful-for-magic` as const,
  MemoryManagementInHexTutorial:
    `${TUTORIAL_BASE_URL}/develop-notebooks/memory-management-in-hex` as const,
  MagicTermsTypeahead:
    `${DOCS_BASE_URL}/legal/hex-magic-beta-terms-and-conditions` as const,
  NotebookAgentBestPractices:
    `${TUTORIAL_BASE_URL}/develop-notebooks/notebook-agent-best-practices` as const,
  SchemaRefreshSchedule:
    `${DOCS_BASE_URL}/connect-to-data/data-connections/data-connections-introduction#schema-refresh-schedules` as const,
  SqlFormatting:
    `${DOCS_BASE_URL}/explore-data/cells/sql-cells/sql-formatting#custom-sql-formatting` as const,
  SlackIntegration:
    `${DOCS_BASE_URL}/administration/slack-integration` as const,
  HexAgentInSlack:
    `${DOCS_BASE_URL}/share-insights/hex-agent-in-slack` as const,
  CustomKernels:
    `${DOCS_BASE_URL}/administration/workspace_settings/custom-images` as const,
  Security: `${MARKETING_SITE_BASE_URL}/security` as const,
  Templates: `${MARKETING_SITE_BASE_URL}/templates` as const,
  ExportDownloadFiles: `${DOCS_BASE_URL}/explore-data/projects/environment-configuration/files#download-files`,
  Explore: `${DOCS_BASE_URL}/share-insights/explore` as const,
  HidePreview:
    `${DOCS_BASE_URL}/explore-data/cells/sql-cells/sql-cells-introduction#hide-preview` as const,
  SqlUnionSortOrder:
    `${DOCS_BASE_URL}/explore-data/cells/sql-cells/sql-cells-introduction#sort-order-of-union-queries` as const,
  ViewData:
    `${DOCS_BASE_URL}/explore-data/cells/visualization-cells/chart-cells#view-data` as const,
  CsvDownload: `${DOCS_BASE_URL}/administration/workspace_settings/workspace-security#allow-viewers-to-download-and-copy-csvs-from-tables`,
  DebugMode: `${DOCS_BASE_URL}/share-insights/apps/debug-apps` as const,
  DebugModePrunedCells:
    `${DOCS_BASE_URL}/share-insights/apps/debug-apps#cell-run-behavior-in-apps` as const,
  PresentationMode:
    `${DOCS_BASE_URL}/share-insights/apps/publish-and-share-apps#presentation-mode` as const,
  S3Integration:
    `${DOCS_BASE_URL}/connect-to-data/cloud-storage-integrations#amazon-s3` as const,
  GoogleDriveIntegration:
    `${DOCS_BASE_URL}/connect-to-data/cloud-storage-integrations#google-drive` as const,
  WorkspaceAssets:
    `${DOCS_BASE_URL}/administration/workspace_settings/workspace-assets` as const,
  WorkspaceSecurityProjectDataConnections:
    `${DOCS_BASE_URL}/administration/workspace_settings/workspace-security#project-data-connections` as const,
  KeyboardShortcutsCommandMode:
    `${DOCS_BASE_URL}/explore-data/notebook-view/keyboard-shortcuts#command-mode` as const,
  SemanticAuthoringModelingWorkbench:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/semantic-authoring/semantic-authoring-overview` as const,
  SemanticAuthoringModelingSpecification:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/semantic-authoring/modeling-specification` as const,
  SemanticLayer:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/intro` as const,
  SemanticLayerSetup:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/intro#setting-up-semantic-model-sync` as const,
  SemanticLayerMetricflowSetup:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/dbt-metricflow#prepare-your-model-for-hex` as const,
  SemanticLayerMetricflowSupportedFeatures:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/dbt-metricflow#supported-features` as const,
  SemanticLayerCubeSupportedFeatures:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/cube#supported-features` as const,
  SemanticLayerCube:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/cube` as const,
  SemanticLayerMetricflow:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/dbt-metricflow` as const,
  SemanticLayerSnowflake:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/snowflake-semantic-views` as const,
  SemanticLayerSnowflakeSupportedFeatures:
    `${DOCS_BASE_URL}/connect-to-data/semantic-models/snowflake-semantic-views#supported-features` as const,
  SignedEmbedding: `${DOCS_BASE_URL}/share-insights/signed-embedding` as const,
  SignedEmbeddingRowLevelSecurity:
    `${DOCS_BASE_URL}/share-insights/embedding/signed-embedding#implement-row-level-security` as const,
  SignedEmbeddingOptimizeAppLoadTime:
    `${DOCS_BASE_URL}/share-insights/embedding/signed-embedding#optimize-app-load-time-for-signed-embedding` as const,
  SignedEmbeddingRunSettings:
    `${DOCS_BASE_URL}/share-insights/embedding/signed-embedding#configure-run-settings` as const,
  Tasks: `${DOCS_BASE_URL}/explore-data/tasks` as const,
  Threads: `${DOCS_BASE_URL}/explore-data/threads` as const,
  SensitiveThreads: `${DOCS_BASE_URL}/explore-data/threads#sensitive` as const,
  GuideBestPractices:
    `${TUTORIAL_BASE_URL}/ai-best-practices/workspace-context-best-practices#workspace-guides` as const,
  WorkspaceGuideLibrary:
    `${DOCS_BASE_URL}/agent-management/context-management/guides#workspace-guide-library` as const,
  WritingGuides:
    `${DOCS_BASE_URL}/agent-management/context-management/guides#writing-guides` as const,
  WorkspaceAiRules:
    `${DOCS_BASE_URL}/administration/workspace_settings/rules-file-intro` as const,
  SetupProgrammaticGuides:
    `${DOCS_BASE_URL}/agent-management/context-management/guides#programmatically-upload-guides-in-ci` as const,
  UploadGuidesViaHexCli:
    `${DOCS_BASE_URL}/agent-management/context-management/guides#uploading-guides-via-the-hex-cli` as const,
  Evals: `${DOCS_BASE_URL}/agent-management/evals` as const,
  ContextStudio: `${DOCS_BASE_URL}/agent-management/context-studio` as const,
  ContextSync:
    `${DOCS_BASE_URL}/agent-management/context-management/sync` as const,
  ContextSyncContextConfigFile:
    `${DOCS_BASE_URL}/agent-management/context-management/sync#create-a-configuration-file` as const,
  ContextSyncOtherCIProviders:
    `${DOCS_BASE_URL}/agent-management/context-management/sync#sync-from-other-ci-providers` as const,
} as const;

export type DocsLinkName = keyof typeof DOCS_LINKS;
export const DocsLinkName = Union(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...(Object.keys(DOCS_LINKS).map((k) => Literal(k)) as any),
) as Runtype<DocsLinkName>;

export type DocsLinkValue = (typeof DOCS_LINKS)[DocsLinkName];

export const MARKETING_SITE_LINKS = {
  RequestExplore: `${MARKETING_SITE_BASE_URL}/request-explore-demo`,
  UseCases: `${MARKETING_SITE_BASE_URL}/use-cases`,
  Pricing: `${MARKETING_SITE_BASE_URL}/pricing`,
  PricingFaq: `${MARKETING_SITE_BASE_URL}/pricing#faq`,
  PricingCompute: `${MARKETING_SITE_BASE_URL}/pricing?modal=compute`,
};
